import { IElementBaseModel } from '../../../Interface/base/element-base-model.interface';
import { afterFlipH, afterFlipV, afterRotate, centerPointOfRect, getLeftTopPointAfterFlip, getPointAfterFlipAndRotate } from '@src/slide/infrastructure/module/independent/graphic';
import SmartArtModel from '@src/slide/domain/ui-model/element-modeles/smart-art-model';
import { enumerateGroup } from '../../group-operation/enumerate';
import { IFrame, IRotateAndFlip } from '../frame.interface';
import { UIModelType } from '../../../constant';
import { IPoint } from '../../../../../../infrastructure/module/independent/graphic/point/point.interface';
import { IGroupModel } from '../../../Interface/group-model.interface';

export class GroupChildrenFrameHanler {
    private model: IElementBaseModel;
    public constructor(model) {
        this.model = model;
    }

    /**
     * 组合中的元素相对于slide的frame信息
     */
    public frameOnSlide(frameOfGroup?: IFrame, isOperation = false): IFrame {
        const frame = frameOfGroup ?? this.model.getFrame?.().getFrameInfo(isOperation);
        if (this.model.parent?.type === UIModelType.GROUP) {
            enumerateGroup(this.model, (groupModel) => {
                const groupFrame = groupModel.getFrame?.().getFrameInfo(isOperation);
                const groupCenterPoint = { x: groupFrame.width / 2, y: groupFrame.height / 2 };
                // 根据翻转修正坐标，获取当前翻转状态下的左上角坐标为left和top
                const { x, y } = getLeftTopPointAfterFlip(frame, groupCenterPoint, groupFrame.flipH, groupFrame.flipV);
                frame.left = x;
                frame.top = y;
                this.fixLeftTopAfterRotateByGroup(frame, groupCenterPoint, groupFrame.rotate);
                this.fixRotateAfterFlipToSlide(frame, { rotate: groupFrame.rotate,
                    flipH: groupFrame.flipH, flipV: groupFrame.flipV });
                frame.left += groupFrame.left;
                frame.top += groupFrame.top;
                this.fixFlipAfterFlipByGroup(frame, groupFrame);
            });
        } else if (this.model.parent?.type === UIModelType.SMART_ART) {
            // const smartArtModel = this.model.parent as SmartArtModel;
            // const smartArtFrame = smartArtModel.getFrame?.().getFrameInfo(isOperation);

            // const cornerPoints = cornerPointsOfRect(frame) ?? [];
            // const { minX, minY } = this.getMinXY(cornerPoints, smartArtFrame);

            // frame.left = minX;
            // frame.top = minY;
            // if (smartArtFrame.flipH === 1) {
            //     frame.flipH = Number(!frame.flipH);
            // }
            // if (smartArtFrame.flipV === 1) {
            //     frame.flipV = Number(!frame.flipV);
            // }

            // let frameCenter = centerPointOfRect(frame)!;
            // if (smartArtFrame.rotate) {
            //     // 改left
            //     const smartArtFrameCenter = centerPointOfRect(smartArtFrame)!;
            //     frameCenter = afterRotate(
            //         frameCenter,
            //         smartArtFrame.rotate,
            //         smartArtFrameCenter.x,
            //         smartArtFrameCenter.y,
            //     );
            //     frame.rotate = (smartArtFrame.rotate + (frame?.rotate || 0)) % 360;
            // }
            // frame.left = frameCenter.x - (frame.width / 2);
            // frame.top = frameCenter.y - (frame.height / 2);

            // return frame;
        }
        return frame;
    }

    /**
     * 当前坐标相对于slide的坐标
     * @param points
     */
    public pointOnSlide(originalPoint: IPoint, isOperating: boolean): IPoint {
        let point = { ...originalPoint };
        if (this.model.parent?.type === UIModelType.GROUP) {
            enumerateGroup(this.model, (groupModel) => {
                const groupFrame = groupModel.getFrame().getFrameInfo(isOperating);
                point.x = groupFrame.left + point.x;
                point.y = groupFrame.top + point.y;
                point = getPointAfterFlipAndRotate(point, groupFrame);
            });
        }
        return point;
    }

    /**
     * slide上的坐标相对于当前元素的坐标
     * @param points
     */
    public pointToElement(originalPoint: IPoint, isOperating: boolean): IPoint {
        let reletivePoint = {
            x: originalPoint.x,
            y: originalPoint.y,
        };
        const groupModels: IGroupModel[] = [];
        let { parent } = this.model;
        while (parent?.type === UIModelType.GROUP) {
            groupModels.unshift(parent as IGroupModel);
            parent = parent.parent;
        }
        groupModels.forEach((groupModel) => {
            reletivePoint = this.getReletivePoint(groupModel, reletivePoint, isOperating);
        });
        return reletivePoint;
    }

    /**
     * 转换元素的变更信息：由相对与slide改为相对于自身的父元素
     */
    public convertFrameOnSlideToSelf(frameOfSlide: IFrame): IFrame {
        const frame = { ...frameOfSlide };
        if (this.model.parent?.type === UIModelType.GROUP) {
            const groupModelArr: IGroupModel[] = [];
            enumerateGroup(this.model, (groupModel) => {
                groupModelArr.unshift(groupModel);
            });
            groupModelArr.forEach((groupModel) => {
                const groupFrame = groupModel.getFrame?.().getFrameInfo();
                const groupCenterPoint = { x: groupFrame.width / 2, y: groupFrame.height / 2 };
                frame.left -= groupFrame.left;
                frame.top -= groupFrame.top;
                // 根据旋转修正坐标
                this.fixLeftTopAfterRotateByGroup(frame, groupCenterPoint, -(groupFrame.rotate ?? 0));
                this.fixRotateAfterFlipToGroup(frame, { rotate: groupFrame.rotate,
                    flipH: groupFrame.flipH, flipV: groupFrame.flipV });
                // 根据翻转修正坐标
                const { x, y } = getLeftTopPointAfterFlip(frame, groupCenterPoint, groupFrame.flipH, groupFrame.flipV);
                frame.left = x;
                frame.top = y;
                this.fixFlipAfterFlipByGroup(frame, groupFrame);
            });
        }
        return frame;
    }

    // private getMinXY(cornerPoints, parentFrame: IFrame) {
    //     let minX = 0;
    //     let minY = 0;
    //     cornerPoints.forEach((point: any, i) => {
    //         point = {
    //             x: parentFrame.left + point.x,
    //             y: parentFrame.top + point.y,
    //         };
    //         // const center = centerPointOfRect(parentFrame);
    //         if (parentFrame?.flipH === 1) {
    //             point = afterFlipH(point, point.x);
    //         }
    //         if (parentFrame?.flipV === 1) {
    //             point = afterFlipV(point, point.y);
    //         }
    //         if (i === 0) {
    //             minX = point.x;
    //             minY = point.y;
    //         } else {
    //             minX = Math.min(minX, point.x);
    //             minY = Math.min(minY, point.y);
    //         }
    //     });
    //     return {
    //         minX,
    //         minY,
    //     };
    // }

    private getReletivePoint(model: IGroupModel, originalPoint: IPoint, isOperating: boolean): IPoint {
        let reletivePoint = {
            x: originalPoint.x,
            y: originalPoint.y,
        };
        const frame = model.getFrame?.().getFrameInfo(isOperating);
        const center = centerPointOfRect(frame)!;
        if (frame.rotate) {
            reletivePoint = afterRotate(
                reletivePoint, 360 - frame.rotate,
                center?.x, center?.y,
            );
        }
        if (frame.flipH === 1) {
            reletivePoint = afterFlipH(reletivePoint, center.x);
        }
        if (frame.flipV === 1) {
            reletivePoint = afterFlipV(reletivePoint, center.y);
        }
        return {
            x: reletivePoint.x - frame.left,
            y: reletivePoint.y - frame.top,
        };
    }

    private fixFlipAfterFlipByGroup(childFrameOfGroup: IFrame, groupFrame: IFrame) {
        if (groupFrame.flipH === 1) {
            childFrameOfGroup.flipH = childFrameOfGroup.flipH === 0 ? 1 : 0;
        }
        if (groupFrame.flipV === 1) {
            childFrameOfGroup.flipV = childFrameOfGroup.flipV === 0 ? 1 : 0;
        }
    }

    /**
     * 消除子元素跟随组合的旋转，修正子元素的位置
     */
    private fixLeftTopAfterRotateByGroup(
        childFrameOfGroupParent: IFrame,
        groupFrameCenter: IPoint, groupRotate = 0,
    ) {
        let frameCenter = centerPointOfRect(childFrameOfGroupParent)!;
        frameCenter = afterRotate(frameCenter, groupRotate, groupFrameCenter.x, groupFrameCenter.y);
        childFrameOfGroupParent.left = frameCenter.x - (childFrameOfGroupParent.width / 2);
        childFrameOfGroupParent.top = frameCenter.y - (childFrameOfGroupParent.height / 2);
    }

    /**
     * 将相对于组合的旋转角度根据组合翻转修正为相对于slide的旋转角度
     */
    private fixRotateAfterFlipToSlide(childFrameOfGroupParent: IFrame, groupInfo: IRotateAndFlip) {
        const { rotate = 0, flipH, flipV } = groupInfo;
        const childRotate = childFrameOfGroupParent.rotate ?? 0;
        // 父组合仅横向有翻转或者纵向有翻转
        const needReverse = flipH !== flipV ? -1 : 1;
        childFrameOfGroupParent.rotate = (rotate + (needReverse * childRotate) + 360) % 360;
    }

    /**
     * 将相对于slide的旋转角度根据组合翻转修正为相对组合的旋转角度
     */
    private fixRotateAfterFlipToGroup(frameOfSlide: IFrame, groupInfo: IRotateAndFlip) {
        const { rotate = 0, flipH, flipV } = groupInfo;
        const childRotate = frameOfSlide.rotate ?? 0;
        // 父组合仅横向有翻转或者纵向有翻转
        const needReverse = flipH !== flipV ? -1 : 1;
        frameOfSlide.rotate = (((childRotate - rotate) / needReverse) + 360) % 360;
    }
}
